<template>  
   <div class="w-table-wrap" style="max-height: 1400px;" >
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'MAKLUMAT TERNAKAN'" >
         <template #title>
            MAKLUMAT KES
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedList = !isMinimizedList">
                  <template v-if="isMinimizedList">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
      <div v-show="!isMinimizedList">
      <div class="w-table-wrap" style="max-height: 1400px;" >
         <div class="w-flex wrap smd-column" >
          <div class="grow " style="line-height: 35px">
            <table >
              <tbody>
              <tr class="row_data">
                 <td><b>Tarikh ET</b><i aria-hidden="true" style=" color: red;">*</i></td>
                 <td><b>:</b></td>
                 <td>
                  <template v-if="(datas.lkp_status_id==34 && datas.perkhidmatan!=1) || datas.lkp_status_id==32 || datas.lkp_status_id==27">
                  <w-input type="date" v-model="datas.tarikh_ai" outline :validators="[validators.required]"></w-input>
                  </template>
                  <template v-else>
                    {{$zutil.dateformat(datas.tarikh_ai)}}
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      <div class="table-profil-scrol">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-center" width="1%">BIL</th>
              <th class="w-table__header  text-center">NO KES ET</th>
              <th class="w-table__header  text-center">ID | NAMA | BAKA TERNAKAN</th>
              <th class="w-table__header  text-center">SUMBER EMBRIO</th>
              <th class="w-table__header  text-center">NO BATCH EMBRIO</th>
              <th class="w-table__header  text-center">BIL STRAW EMBRIO</th>
              <th class="w-table__header  text-center">GRED EMBRIO</th>
              <th class="w-table__header  text-center">STAGE EMBRIO</th>
              <th class="w-table__header  text-center">ID PEJANTAN | ID BETINA</th>
              <th class="w-table__header  text-center">HARGA EMBRIO PER STRAW(RM)</th>
              <th class="w-table__header  text-center">TARIKH JANGKAAN PD</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="ternakan_list.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan_list">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" style="margin:5px;">{{datas.no_permohonan}}</td>
                <td class="w-table__cell text-left" style="margin:25px;">{{dt.ternakan_nama}} | {{dt.baka}}</td>
                <td class="w-table__cell text-left" style="margin:10px;"><div style="width: 210px"></div>
                 <template v-if="(datas.perkhidmatan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                   {{dt.lkp_kategori_semen}}
                 </template>
                 <template v-else>
                   <w-select style="margin:10px;" placeholder="Pilih Satu.." outline :items="kategori_semen" @input="lookupStock(dt)" v-model="dt.lkp_kategori_semen_id" />
                 </template>
               </td>
                <td class="w-table__cell text-left" style="margin:15px;"><div style="width:150px"></div>
                  <!-- <template v-if="dt.lkp_kategori_semen_id==3">
                     <template v-if="(datas.perkhidmatan==1 && datas.lkp_status_id!=27)">
                        {{dt.no_batch}}  
                     </template>
                     <template v-else>
                           <w-input style="margin:10px;"  placeholder="No Batch Semen" v-model="dt.no_batch" :validators="[validators.required]" outline/>
                     </template>
                  </template>
                  <template v-else>
                     <template v-if="(datas.perkhidmatan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                      {{dt.no_batch_keterangan}}
                     </template>
                     <template v-else>
                      <w-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt)" outline :items="dt.list_stock_e" v-model="dt.se_stock_id"/>
                     </template> -->
                     <template v-if="(datas.perkhidmatan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                      {{dt.no_batch_keterangan}}
                     </template>
                     <template v-else>
                      <w-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt)" outline :items="dt.list_stock_e" v-model="dt.se_stock_id"/>
                     </template>
                </td>
                <td class="w-table__cell text-right" style="margin:5px;"><div style="width:70px"></div>
                  <template v-if="(datas.perkhidmatan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                    {{dt.bil_straw}}
                  </template>
                  <template v-else>
                    <w-input style="margin:10px;" outline v-model="dt.bil_straw" @keyup="cekBakiStraw(dt)" :validators="[validators.required, validators.numeric]" :disabled="!dt.se_stock_id && dt.lkp_kategori_semen_id!=3"/>
                  </template>
                </td>
                <td class="w-table__cell text-left" style="margin:5px;">
                  <!-- <template v-if="dt.lkp_kategori_semen_id==3 || dt.lkp_status_id == 28">
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                        {{dt.gred}}
                     </template>
                     <template v-else>
                        <w-input placeholder="Sila Masukan.." v-model="dt.gred" :validators="[validators.required]" outline/>
                     </template>
                  </template>
                  <template v-else>
                     {{dt.gred}}
                  </template> -->
                  {{dt.gred}}
                </td>
                <td class="w-table__cell text-left" style="margin:5px;">
                  <!-- <template v-if="dt.lkp_kategori_semen_id==3 || dt.lkp_status_id == 28">
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                        {{dt.stage}}
                     </template>
                     <template v-else>
                        <w-input placeholder="Sila Masukan.." type="number" v-model="dt.stage" :validators="[validators.required]" outline/>
                     </template>
                  </template>
                  <template v-else>
                     {{dt.stage}}
                  </template> -->
                  {{dt.stage}}
                </td>
                <td class="w-table__cell text-left" style="margin:5px;"><div style="width:150px"></div>
                  <!-- <template v-if="dt.lkp_kategori_semen_id==3 || dt.lkp_status_id == 28">
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                        {{dt.id_ternakan_batch}} | {{dt.id_ternakan_betina}}
                     </template>
                     <template v-else>
                        <w-flex wrap :gap="2">
                           <div class="grow mb2" style="min-width: 200px">
                              <w-input placeholder="ID Jantan" v-model="dt.id_ternakan_batch" :validators="[validators.required]" outline/>
                              <w-input placeholder="ID Betina" v-model="dt.id_ternakan_betina" :validators="[validators.required]" outline/>
                           </div>
                        </w-flex>
                     </template>
                  </template>
                  <template v-else>
                    <template v-if="dt.id_jantan!=null">{{dt.id_jantan}} | </template>{{dt.id_betina}}
                  </template> -->

                    <template v-if="dt.id_jantan!=null">{{dt.id_jantan}} | </template>{{dt.id_betina}}
                </td>
                <td class="w-table__cell text-right" style="margin:5px;">
                  <template v-if="(dt.lkp_kategori_semen_id==3 && (datas.lkp_status_id==27||datas.lkp_status_id==34)) || dt.lkp_status_id == 28">
                     <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="dt.harga_straw" outline :validators="[validators.required]"/>
                  </template>
                  <template v-else>
                     {{$zutil.formatDecimal(dt.harga_straw)}}
                  </template>
                </td>
                <td class="w-table__cell text-left" style="margin:5px;"><div style="width: 100px"></div>
                  <template v-if="(datas.perkhidmatan==1 && datas.lkp_status_id!=27) || dt.lkp_status_id == 28">
                    {{$zutil.dateformat(dt.jankaan_biang_semula)}}
                  </template>
                  <template v-else>
                     <w-input type="date" outline v-model="dt.jankaan_biang_semula"></w-input>
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        </div>
        <!-- <w-flex class="mt3" wrap align-center justify-end v-if="(datas.perkhidmatan!=1 && datas.lkp_status_id==34)||(datas.perkhidmatan==1 && datas.lkp_status_id==27)">
          <w-button class="my1" :loading="loading" @click="send(2); onSuccess()">
            <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
          </w-button>
          &nbsp;
          <w-button class="my1" bg-color="success" type="submit" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button>
        </w-flex> -->
      </div>
      </div>
      </w-card>
      <br><br>
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" >
         <template #title>
            CAJ PERKHIDMATAN ET
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedCaj = !isMinimizedCaj">
                  <template v-if="isMinimizedCaj">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
         <div v-show="!isMinimizedCaj">
         <br>
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
                <table width="100%">
                  <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>1.</b></td>
                     <td width="22%"><b>Konsultasi / Perkhidmatan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <w-radios
                             :items="ya_tidak"
                             v-model="datas.konsutasi_ya_tidak"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.konsutasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                      <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi" @input="kiraan_caj(datas)"  outline/>
                        </div>
                        <div v-else>
                           RM {{$zutil.formatDecimal(datas.konsutasi)}}
                        </div>
                        
                     </td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
            <table class="w-table" color="light"  width="100%">
              <thead>
                <tr>
                  <td width="2%"><b>2. </b></td>
                  <td align="left" width="25%"><b>Harga Embrio</b></td>
                  <td align="center" width="20%"><b>ID Ternakan | No Batch</b></td>
                  <td align="center" width="20%"><b>Harga (RM)</b></td>
                  <td align="center" width="13%"><b>Kuantiti </b></td>
                  <td align="center" width="20%"><b>Jumlah (RM)</b></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td align="left">i. Embrio Subsidi Jabatan (IBVK) </td>
                  <td align="center">
                     <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                     {{stock.no_batch_keterangan}}
                     </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                     <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                     {{$zutil.formatDecimal(stock.harga)}}
                      </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>ii. Embrio Subsidi Jabatan (NEGERI)</td>
                  <td align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{stock.no_batch_keterangan}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" aalign="right">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{$zutil.formatDecimal(stock.harga)}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>iii. Embrio Persendirian</td>
                  <td align="center">
                     <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirian" v-else>
                    {{stock.no_batch_keterangan}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirian" v-else>
                    {{$zutil.formatDecimal(stock.harga)}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirian" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirian" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
         </div>
          <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>3.</b></td>
                     <td width="22%"><b>Caj Perjalanan (RM)</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                           
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_pengangkutan"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                            <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           RM {{$zutil.formatDecimal(datas.pengangkutan)}}
                        </div>
                     </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="mx2"></div>
        </div>



         <div class="w-flex wrap smd-column" >
            <!-- <div class="mx2"></div> -->
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>4.</b></td>
                     <td width="22%"><b>Caj Lain-Lain (Jika Ada) (RM)</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_caj_lain"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                             <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                    </td>
                     <td width="31%" align="right"> 
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                             <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_lain" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           RM {{$zutil.formatDecimal(datas.caj_lain)}}
                        </div>
                     </td>
                  </tr>
                  <template v-if="datas.caj_lain!=0">
                  <tr class="row_data">
                     <td width="1%"><b></b></td>
                     <td width="22%"><b>Nyatakan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td colspan="2">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                              <z-input style="margin:5px;" label="" class="mt4" v-model="datas.nyatakan" @input="kiraan_caj(datas)" placeholder="Sila Masukan.." :validators="[validators.required]" outline/>
                        </div>
                        <div v-else>
                            <b>{{datas.nyatakan}}</b>
                        </div> 
                     </td>
                     <td colspan="2"></td>
                  </tr>
                  </template>
                  <template v-else>
                  <tr class="row_data">
                     <td colspan="7"><div style="margin:17px;" class="fw-normal my1 fs-1"></div>  </td>
                     <td></td>
                  </tr>
                  </template>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                 <tbody>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Keseluruhan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.keseluruhan)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Subsidi Kerajaan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.subsidi)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Yang Perlu Dibayar</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.perlu_bayar)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
          </div>
        </div>
      </w-card>
      <w-flex class="mt3" wrap align-center justify-end v-if="(datas.lkp_status_id==34)||(datas.perkhidmatan==1 && datas.lkp_status_id==27)">
        <w-button class="my1" :loading="loading" :disabled="loading" type="submit">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
      </w-flex>
    </w-form>
  </div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.et-aiman',
      form : {},
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      ternakan_list:[],
      list_stock:[],

      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],

      ya_tidak:[
         {value: 1, label: "Berbayar"},
         {value: 2, label: "Subsidi"},
      ],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => value !== '' || !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      isMinimizedList:false,
      isMinimizedCaj:false,
      kategori_semen:[],
      lkp_baka:[],
      negri:[],
      ibvk:[],
      persendirian: [],
      
    }
  },
  methods:{
      kiraan_caj(){

      var total_harga = 0;

      let ibvk = [];
      ibvk = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 1)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let negri = [];
      negri = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 2)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let persendirian = [];
      persendirian = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 3)
         .map((item) => ({
           no_batch_keterangan: item.no_batch,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);

    // Output
    console.log('No Batch List:', ibvk);
      var no_batch_keterangan = [];
      for (var b in this.ternakan_list){
        if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
          no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
        // }else if (this.ternakan_list[b].lkp_jenis_hormon_id==2) {
        //   prid_delta_kuantiti+=1;
        //   prid_delta_harga = this.ternakan_sinkronisasi[b].harga;
        //   prid_delta_jumlah += Number(this.ternakan_sinkronisasi[b].harga);
        // }else if (this.ternakan_sinkronisasi[b].lkp_jenis_hormon_id==3) {
        //   jumlah_persendirian += Number(this.ternakan_sinkronisasi[b].harga_hormon_1) + Number(this.ternakan_sinkronisasi[b].harga_hormon_2) + Number(this.ternakan_sinkronisasi[b].harga_hormon_3)
        }
        // total_harga += Number(this.ternakan_list[b].harga);
      }
      this.ibvk = ibvk;
      this.negri = negri;
      this.persendirian = persendirian;
      this.datas.keseluruhan = Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
      if(this.datas.jenis_pengguna_pemohon == 1){
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.caj_lain);
         }
         this.datas.subsidi = subsidi;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi;
      }else{
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(this.datas.konsutasi) + Number(totalNegri);
            // var perlu_bayar = Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri);
            // var perlu_bayar = Number(this.datas.konsutasi) + Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }
         if(this.datas.bayar_pengangkutan==2){ 
             var subsidi_pengangkutan =  Number(this.datas.pengangkutan) ;
         }else{
            var subsidi_pengangkutan = 0;
         }

         if(this.datas.bayar_caj_lain==2){ 
             var subsidi_lain =  Number(this.datas.caj_lain) ;
         }else{
            var subsidi_lain = 0;
         }
         this.datas.subsidi = subsidi + subsidi_pengangkutan + subsidi_lain;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi -  subsidi_pengangkutan - subsidi_lain;
      }

      // console.log(datas.perlu_bayar)
    },
    lkpBerahi()
    {
      this.$zcomm.get(this.api_service + 'lookup/berahi', {}).then(res => {
        this.lkp_berahi = res
      })
    },
    lookupStock(dt)
    {
        // alert(dt.lkp_kategori_semen_id)
      dt.list_stock_e = []
      for (var b in this.listStock) {
         // if (this.listStock[b].lkp_baka_id == dt.jenis_semen) {

            if(dt.lkp_kategori_semen_id == 3 && this.listStock[b].user_id == this.$page.props.auth.user.id){
              dt.list_stock_e.push({ 
                 baki: this.listStock[b].baki,
                 gred: this.listStock[b].gred,
                 harga: this.listStock[b].harga,
                 id_betina: this.listStock[b].id_betina,
                 id_jantan: this.listStock[b].id_jantan,
                 label: this.listStock[b].id_jantan+' | '+this.listStock[b].label,
                 stage: this.listStock[b].stage,
                 value: this.listStock[b].value,
              });
            }


            if(dt.lkp_kategori_semen_id == 2 && this.listStock[b].user_id != this.$page.props.auth.user.id && this.listStock[b].dvs == 1){
              dt.list_stock_e.push({ 
                 baki: this.listStock[b].baki,
                 gred: this.listStock[b].gred,
                 harga: this.listStock[b].harga,
                 id_betina: this.listStock[b].id_betina,
                 id_jantan: this.listStock[b].id_jantan,
                 label: this.listStock[b].id_jantan+' | '+this.listStock[b].label,
                 stage: this.listStock[b].stage,
                 value: this.listStock[b].value,
              });
            }

            if(dt.lkp_kategori_semen_id == 1 && this.listStock[b].user_id != this.$page.props.auth.user.id && this.listStock[b].dvs != 1){
              dt.list_stock_e.push({ 
                 baki: this.listStock[b].baki,
                 gred: this.listStock[b].gred,
                 harga: this.listStock[b].harga,
                 id_betina: this.listStock[b].id_betina,
                 id_jantan: this.listStock[b].id_jantan,
                 label: this.listStock[b].id_jantan+' | '+this.listStock[b].label,
                 stage: this.listStock[b].stage,
                 value: this.listStock[b].value,
              });
            }
         // }
      }
      
    },

    getStock(ind){
      this.$zcomm.get(this.api_service + 'lookup/stock/2', {}).then(res => {
         this.listStock = res
         if(ind == 1){
          for (var b in this.ternakan_list) {
            if(this.ternakan_list[b].se_stock_id == null || this.ternakan_list[b].se_stock_id == ''){
              this.lookupStock(this.ternakan_list[b])
            }
          }
          
         }
      })
    },
    getHarga(dt){
      for (var b in dt.list_stock_e) {
        if(dt.list_stock_e[b].value == dt.se_stock_id){
          dt.harga_straw = dt.list_stock_e[b].harga;
          dt.max_kuantiti_straw = dt.list_stock_e[b].baki;
          dt.stage = dt.list_stock_e[b].stage;
          dt.gred = dt.list_stock_e[b].gred;
          dt.id_jantan = dt.list_stock_e[b].id_jantan;
          dt.id_betina = dt.list_stock_e[b].id_betina;
        }
      }
    },
    cekBakiStraw(dt){
      if(dt.bil_straw > dt.max_kuantiti_straw){
        dt.bil_straw = dt.max_kuantiti_straw;
      }
    },

    getTernakan(){
      // ternakan list
      for (var b in this.datas.ternakan_list) {
        if(this.datas.ternakan_list[b].status_pemeriksaan ==1){
          // this.getHarga(this.datas.ternakan_list[b]);
          this.ternakan_list.push({
            id:this.datas.ternakan_list[b].id,
            art_id:this.datas.ternakan_list[b].art_id,
            bil_straw:this.datas.ternakan_list[b].bil_straw,
            baka:this.datas.ternakan_list[b].baka,
            ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
            bunting:this.datas.ternakan_list[b].bunting,
            harga_straw:this.datas.ternakan_list[b].harga_straw,
            id_ternakan:this.datas.ternakan_list[b].id_ternakan,
            jankaan_biang_semula: this.datas.ternakan_list[b].jankaan_biang_semula || this.jankaanBiangSemula(this.datas.ternakan_list[b].jankaan_biang_semula),
            pemeriksaan_kebuntingan:this.jankaanBiangSemula(this.datas.ternakan_list[b].pemeriksaan_kebuntingan),
            jankaan_kelahiran: this.jankaanKelahiran(this.datas.ternakan_list[b].jankaan_kelahiran),
            lkpBerahi_keterangan:this.datas.ternakan_list[b].lkpBerahi_keterangan,
            lkp_berahi_id:this.datas.ternakan_list[b].lkp_berahi_id,
            no_kes:this.datas.ternakan_list[b].no_kes,
            se_stock_id:this.datas.ternakan_list[b].se_stock_id,
            skor_badan:this.datas.ternakan_list[b].skor_badan,
            status:this.datas.ternakan_list[b].status,
            ternakan_id:this.datas.ternakan_list[b].ternakan_id,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            list_stock: this.datas.ternakan_list[b].list_stock,
            list_stock_e: this.datas.ternakan_list[b].list_stock_e,
            max_kuantiti_straw:this.datas.ternakan_list[b].max_kuantiti_straw,
            gred:this.datas.ternakan_list[b].gred,
            stage:this.datas.ternakan_list[b].stage,
            id_betina:this.datas.ternakan_list[b].id_betina,
            id_jantan:this.datas.ternakan_list[b].id_jantan,
            no_batch_keterangan:this.datas.ternakan_list[b].no_batch_keterangan,
            lkp_kategori_semen_id: this.datas.ternakan_list[b].lkp_kategori_semen_id,
            lkp_kategori_semen: this.datas.ternakan_list[b].lkp_kategori_semen,
            jenis_semen: this.datas.ternakan_list[b].jenis_semen,
            no_batch: this.datas.ternakan_list[b].no_batch,
            id_ternakan_batch: this.datas.ternakan_list[b].id_ternakan_batch,
            id_ternakan_betina: this.datas.ternakan_list[b].id_ternakan_betina,
            lkp_status_id: this.datas.ternakan_list[b].lkp_status_id,
          })
       }
      }
      this.kiraan_caj();
    },

    jankaanBiangSemula(tarikh){
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + this.datas.ternakan_biang_semula); //tambah  hari untuk lembu
      const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
      return formattedDate;
    },
    //belum benar
    bilanganInseminasi() {
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      const tarikh_sekarang = new Date();

      const batasTanggal = new Date(tarikh_sekarang);
      batasTanggal.setMonth(batasTanggal.getMonth() + 3);
      if(tarikh_pemeriksaan == tarikh_sekarang){
        return 1;
      }else if(tarikh_pemeriksaan > tarikh_sekarang && tarikh_pemeriksaan <= batasTanggal){
        return 2;
      }else if(tarikh_pemeriksaan > batasTanggal){
         return 3;
      }
      return 1;
      // return formattedDate;
    },

      jankaanKelahiran(tarikh){
         const usia_bunting_0 = 0;
        const bunting_ternakan = this.datas.bunting_ternakan;
        const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
        const totalhari = bunting_ternakan - usia_bunting_0;

        tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + totalhari);
        const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
        return formattedDate;
     },

    validateForm() {
      this.loading=true;
      let isValid = true;

      this.ternakan_list.forEach((row) => {
        if (!row.bil_straw || !row.skor_badan) {
          isValid = false;
          this.loading=false;
        }
        // if (row.lkp_kategori_semen_id == 3 && (row.id_ternakan_betina ==null || row.id_ternakan_batch == null|| row.no_batch==null)) {
        //     isValid = false;
        //     this.loading=false;      
        //  }
        //  if (!row.se_stock_id && row.lkp_kategori_semen_id !=3 ) {
        //     isValid = false;
        //     this.loading=false; 
        //  }
         if (!row.se_stock_id  ) {
            isValid = false;
            this.loading=false; 
         }
      });

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.ternakan_list, perkhidmatan:1, hantar:1})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
               this.$inertia.visit(this.$route('art.semakan.et-aiman',this.datas.id)+'?tab=2');
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
               this.$inertia.visit(this.$route('art.semakan.et-aiman',this.datas.id)+'?tab=2');
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
         var param = {
            ternakan_list: this.ternakan_list,
            perkhidmatan:1,
            tarikh_ai:  this.datas.tarikh_ai,
            konsutasi: this.datas.konsutasi,
            pengangkutan: this.datas.pengangkutan,
            keseluruhan: this.datas.keseluruhan,
            subsidi: this.datas.subsidi,
            perlu_bayar: this.datas.perlu_bayar,
            caj_lain: this.datas.caj_lain,
            konsutasi_ya_tidak: this.datas.konsutasi_ya_tidak,
            bayar_pengangkutan: this.datas.bayar_pengangkutan,
            bayar_caj_lain: this.datas.bayar_caj_lain,
            nyatakan: this.datas.nyatakan,

          }
          
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, param)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
               this.$inertia.visit(this.$route('art.semakan.et-aiman',this.datas.id)+'?tab=4');
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
               this.$inertia.visit(this.$route('art.semakan.et-aiman',this.datas.id)+'?tab=4');
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
    lkpKategoriSemen()
    {
      this.$zcomm.get(this.api_service + 'lookup/kategori_semen', {}).then(res => {
        this.kategori_semen = res
      })
    },
   chekLkpKategori(dt){
      if (dt.lkp_kategori_semen_id == 3) {
         dt.se_stock_id = null;
      }else{
         dt.no_batch = null;
         dt.id_ternakan_batch = null;
      }
    },
  },
      
  mounted() {
   if (this.datas.tarikh_ai == null) {
      var today = new Date();
      this.datas.tarikh_ai = this.datas.tarikh_pemeriksaan;
   }
    this.lkpBerahi()
    this.getTernakan();
    this.getStock(0);
    this.lkpKategoriSemen()
    // this.datas = this.data;
  }
}
      

</script>  
<style type="text/css">

/*.w-table__row {
  display: flex;
  align-items: center;
}*/
.w-table__cell {
  vertical-align: middle;
}

</style>
